export default __webpack_public_path__ + "static/media/launch_black_24dp.9302ca7a.svg";